import * as React from 'react';
import Svg, {
  SvgProps, G, Path, Defs, ClipPath,
} from 'react-native-svg';

const SupportPeopleLogo = (props: SvgProps) => (
  <Svg
    width={263}
    height={140}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="#EBF1F9"
        d="M260.566 321.73H.298c1.273-35.821-.402-77.028.268-117.226.67-40.332.804-73.864.804-119.785 0-17.17 7.166-41.006 27.326-48.48 20.428-7.676 76.017-8.08 98.186-8.416 22.035-.27 82.515-1.414 103.813 5.925 18.217 6.262 27.527 22.49 29.268 42.285 3.416 38.851 2.88 85.311 2.344 124.094l-1.741 121.603Z"
      />
      <Path
        fill="#B0CBE6"
        d="M69.761 109.952h-2.248l-4.398 99.493h2.248l4.398-99.493ZM193.343 109.952h2.248l4.398 99.493h-2.199l-4.447-99.493ZM59.841 109.952h-2.248l-4.398 99.493h2.248l4.398-99.493ZM203.019 109.952h2.247l4.398 99.493h-2.199l-4.446-99.493Z"
      />
      <Path
        fill="#B0CBE6"
        d="M217.385 104.327H45.475V111h171.91v-6.673ZM180.359 23.558c2.003 12.043 6.89 10.496 4.838 26.297l1.026-.332c.098-1.326-.245-2.817.391-3.812 2.443-3.867 1.368-15.082-6.255-22.153ZM199.71 33.17c-5.718 5.635-6.744 6.85-9.041 12.762.098-1.437.294-3.315 1.222-6.243 1.319-3.701 1.955-7.348 1.955-7.348-2.053 2.818-6.842 10.884-3.958 16.243a21.4 21.4 0 0 0-.294 6.463l1.369 1.603c-.196-3.536-.098-6.188.195-8.232 2.688 1.381 14.562-1.768 13.78-1.989-3.518-3.37-7.818-.276-13.536.663 4.007-6.74 6.695-4.364 14.709-18.673 0 .055-3.812 2.21-6.401 4.751Z"
      />
      <Path
        fill="#B0CBE6"
        d="M186.809 53.888c-4.838-6.133-7.721-8.01-17.201-5.912 9.285 6.299 14.318 2.044 16.859 7.072-3.958-1.657-11.581 2.762-11.874 5.248 0 0 3.86.332 6.303-1.326 3.812-2.596 5.473-3.093 6.109-3.149.733 1.16 1.466 2.542 2.248 4.31l.879-1.658c-.537-.829-1.124-1.657-1.661-2.43-1.76-6.41-4.398-16.353-11.044-17.237.049 1.326 7.818 11.104 9.382 15.082Z"
      />
      <Path
        fill="#B0CBE6"
        d="M201.762 53.28c-9.138 8.674-10.36 8.729-15.539 18.563l-.636-1.105c.733-1.216 1.369-2.431 2.004-3.591-1.906-4.752 1.515-13.646 5.229-16.74 1.319 3.591-3.714 11.989-4.496 15.359 4.105-7.403 4.935-11.215 13.438-12.486Z"
      />
      <Path
        fill="#B0CBE6"
        d="M182.656 104.327h11.874l5.424-37.733h-22.723l5.425 37.733ZM52.989 51.827c1.3 7.829 4.474 6.823 3.141 17.093l.667-.215c.063-.862-.159-1.832.254-2.478 1.586-2.514.888-9.803-4.062-14.4Z"
      />
      <Path
        fill="#B0CBE6"
        d="M67.332 54.448s-1.904 1.006-3.173 2.406c-2.73 3.088-3.173 5.925-4.348 9.768.064-.934-.317-1.975.032-3.879.571-3.016-1.333-5.099-1.333-5.099-.761 1.329-.222 4.56.413 7.577.254 1.113.444 2.263.476 3.196-.222 1.257-.254 2.657-.159 4.202l.698 1.04c-.095-2.297-.031-4.02.127-5.35 1.365.898 9.171 2.586 8.79 2.442-1.808-2.19-5.743-3.914-8.663-3.303 1.301-4.381 4.19-5.495 7.14-13ZM57.178 71.542c-3.84-4.597-5.68-8.224-11.615-7.505 5.617 6.284 7.426 2.657 11.424 8.295-2.57-1.077-6.093 1.903-6.251 3.483 0 0 2.157.682 3.395-.862 1.555-1.903 2.793-2.047 3.205-2.118.476.754.952 1.652 1.46 2.8l.571-1.077c-.349-.538-.73-1.077-1.079-1.58-1.142-4.165-2.856-10.629-7.172-11.204 0 .826 5.014 7.182 6.062 9.768Z"
      />
      <Path
        fill="#B0CBE6"
        d="M58.161 79.298c.508-2.19 3.745-7.648 2.92-9.983-2.412 1.975-4.633 7.793-3.396 10.881-.412.754-.825 1.544-1.3 2.334l.412.718c3.364-6.427 1.27-3.555 7.203-9.193-5.553.79-5.743 3.7-5.839 5.243Z"
      />
      <Path
        fill="#B0CBE6"
        d="M54.48 104.327h7.711l3.523-24.526H50.926l3.554 24.526Z"
      />
      <Path
        fill="#EBA398"
        d="M182.201 72.078c1.613.22 3.665-.496 4.642-.772 1.222-.386 2.59-.441 3.177-.441.391 0 .391-.662-.489-.938-.977-.33-3.518-.276-4.447.11-.928.387-2.883 2.041-2.883 2.041Z"
      />
      <Path
        fill="#002950"
        d="M155.716 199.698c-.196-4.577-1.515-61.438-1.759-65.961-.245-4.798.586-22.17.586-22.17l3.909-16.435 9.676-2.537s2.296 28.623 1.515 40.481c-.685 10.589-2.444 57.798-3.47 66.402-1.124.165-8.894.882-10.457.22Z"
      />
      <Path
        fill="#002950"
        d="M154.885 135.116c-.88 3.364-.782 18.089-1.319 26.748-1.32 21.895-1.711 38.165-1.711 38.165-1.857 0-6.548-.111-8.405-.276l-1.466-.166c.049-3.198-1.368-21.895-2.052-39.874-.391-9.927-2.443-31.932-2.541-37.337-.244-15.994 1.368-26.859 1.368-26.859l23.26-2.757-4.007 25.81c-1.075 6.674-2.199 12.961-3.127 16.546Z"
      />
      <Path
        fill="#EBA398"
        d="M149.608 29.391c.098 2.923-.44 4.413-.929 5.846-.439 1.49-5.277 4.633-5.277 4.633s14.269 14.946 19.546 14.725c5.229-.22-2.59-15.607-2.59-15.607s-2.247-1.434-2.736-2.978c-.489-1.545-.88-5.13-.88-5.13l-6.303-8.548-.831 7.06Z"
      />
      <Path
        fill="#D4877B"
        d="M150.683 35.016c-.538-.386-1.075-.772-1.564-1.213.293-1.103.538-2.427.489-4.412l.831-7.115 6.303 8.549s.342 3.585.88 5.129c.049.22.146.386.244.606-3.811.497-5.326-.661-7.183-1.544Z"
      />
      <Path
        fill="#F5B335"
        d="m161.971 42.462 1.661-2.537s4.007 1.323 6.011 4.302c2.003 3.033 5.228 20.185 5.57 21.067.342.828.978 5.626.685 6.343-.294.717-2.932 6.121-4.692 6.177-1.71.055-3.323-4.964-5.473-10.534-2.199-5.57-3.762-24.818-3.762-24.818Z"
      />
      <Path
        fill="#F5B335"
        d="M167.737 75.94c.391 3.032 2.101 7.996 5.571 8.106 1.661.055 6.841-4.963 8.356-7.666 2.492-4.357 1.514-5.9 1.514-5.9s-3.176 1.378-3.274-1.82c0 0-6.352.165-7.036 1.268-.684 1.213-5.131 6.011-5.131 6.011Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.177}
        d="M170.815 73.843s4.398-3.53 6.109-3.97"
      />
      <Path
        fill="#87621D"
        d="M176.924 69.927c-.44 2.04.83 4.357 2.785 4.522 3.323.22 3.323-2.371 3.078-4.412l-5.863-.11Z"
      />
      <Path
        fill="#F7EDE6"
        d="M138.271 100.039c-.685 1.876-1.075 3.916-.685 4.468.391.551 10.702 1.544 17.739 1.654 7.036.11 13.194-1.213 13.975-3.033.782-1.765-.684-5.57-.684-5.57l-30.345 2.481Z"
      />
      <Path
        fill="#F5B335"
        d="M147.164 37.112s-7.721 4.964-8.942 6.288c-2.444 2.757-2.493 7.941-2.297 11.802.147 3.254.733 33.918.928 43.514.049 1.765 1.075 3.364 2.639 3.805 1.173.387 2.59.773 4.251.993 4.447.717 12.315.993 15.638.497 4.007-.607 7.329-1.71 9.528-2.537 1.564-.607 2.541-2.372 2.395-4.247-.929-10.038-3.763-41.75-4.251-45.003-.538-3.86-3.323-12.354-3.323-12.354l-3.861-1.379c-.146 1.544-2.101 2.592-5.277 2.537-3.861-.055-7.428-3.916-7.428-3.916Z"
      />
      <Path
        fill="#F7EDE6"
        d="M147.555 36.506s2.541 3.144 7.037 4.522c0 0-1.222.166-2.053.772-.781.552-1.368 1.71-.83 3.2 0 0-2.981-1.766-4.594-5.295-.684-1.545-.733-2.482-.733-2.482l1.173-.717ZM158.99 37.388c.44.551.977.992 1.564 1.323-.049.166-.147.386-.244.607-1.515 3.64-3.665 5.294-3.665 5.294.195-1.378.048-1.985-.538-2.867-.244-.386-1.417-.717-1.417-.717 2.834-1.048 3.421-2.427 4.3-3.64Z"
      />
      <Path
        fill="#EBA398"
        d="M159.674 14.28c1.71 2.592 1.857 6.067 1.759 7.942-.098 1.875.098 2.04.342 4.467.342 3.144-.831 6.398-2.883 7.997-2.541 2.04-6.89.22-8.649-2.758-1.075-1.765-2.786-4.577-3.225-6.121-.44-1.545-1.906-6.84-.294-9.32 1.613-2.483 4.936-2.98 8.356-2.814 3.47.221 3.861-.496 4.594.607Z"
      />
      <Path
        fill="#302426"
        d="M148.435 21.505s1.27-2.096 1.466-3.806c.146-1.6-.294-2.923-.294-2.923s1.613.386 2.444.497c6.01.827 7.818-.607 7.818-.607s3.812-3.53.831-6.508c-1.564-1.6-1.71.827-3.714 1.213-4.349.828-5.277-.44-8.16 0-3.568.552-2.493 3.144-2.493 3.144s-1.808.551-2.541 2.923c-.733 2.427-.146 4.246.831 6.894 1.319 3.585 4.007 5.24 4.007 5.24l-.489-3.365.733-.772-.439-1.93Z"
      />
      <Path
        fill="#302426"
        d="M155.52 18.195s-2.443-.33-4.691 1.545c0 0 .44.055.586 0 .44-.056 2.932-.938 4.496-.442 0 0 .049-.661-.391-1.103ZM158.306 19.078s-.147-.552.098-1.103c0 0 1.123-.662 3.322.386 0 0-.048.33-.439.276-.44 0-1.955-.221-2.981.44ZM152.686 22.387c.049.551.342.992.587.937.293-.055.488-.496.439-1.048-.048-.551-.342-.992-.586-.937-.293 0-.489.496-.44 1.048ZM159.088 21.67c.048.551.342.992.586.937.293-.055.489-.496.44-1.048-.049-.551-.342-.992-.587-.937-.293 0-.488.496-.439 1.048Z"
      />
      <Path
        fill="#EBA398"
        d="M147.848 23.876c-1.27-1.158-3.078-.607-2.687 1.268.342 1.545 1.075 1.765 2.345 2.923.88.772 1.515.22 1.515-.22-.049-1.324-.391-3.254-1.173-3.971Z"
      />
      <Path
        fill="#D4877B"
        d="M156.644 22.166c.391.386.733.827 1.124 1.213.342.441.733.883 1.075 1.269l.244.33.147.166c.049.055.098.166.147.22 0 .111.048.166.048.276v.276a.908.908 0 0 1-.195.386c-.391.442-.586.552-1.075.717 0 0-.342 0-.147-.165.196-.166.88-.496 1.026-.717.147-.22.196-.441.098-.607-.049-.055-.049-.11-.098-.165l-.146-.166-.244-.33a22.454 22.454 0 0 1-.978-1.324c-.44-.441-.733-.883-1.026-1.379ZM146.822 23.987c-.586-.386-1.026.165-1.075.772-.049.607.098.22.44-.166.342-.386.928.386.977.938.098.772.489 1.71 1.124 1.655.586-.056.244-.221 0-1.048-.244-.773.049 0-.293-.773-.293-.716-.635-1.047-1.173-1.378Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.177}
        d="M166.955 52.28s2.395 24.983 2.639 29.615"
      />
      <Path
        fill="#302426"
        d="M158.648 28.62c-.587.44-1.808.992-2.883.55 0 0 .439 1.6 1.808 1.104 1.124-.386 1.075-1.655 1.075-1.655Z"
      />
      <Path
        stroke="#3D415B"
        strokeMiterlimit={10}
        strokeWidth={1.177}
        d="M157.035 114.71c.489-4.357-2.883 24.818-4.202 32.649"
      />
      <Path
        fill="#121B23"
        d="M163.73 68.77h5.864l5.864-23.109h-3.519c-.537 0-1.075.386-1.221.993l-6.988 22.115Z"
      />
      <Path
        fill="#4A535A"
        d="m164.903 68.438 26.29.386 5.668-22.391c.098-.331-.146-.717-.488-.717h-24.189c-.196 0-.391.165-.489.386l-6.792 22.336Z"
      />
      <Path
        fill="#4A535A"
        d="M164.805 68.273h26.632v.717c0 .552-.391.993-.879.993h-25.753v-1.71Z"
      />
      <Path
        fill="#121B23"
        d="M152.882 68.273h11.923c.342 0 .635.331.635.717v.276c0 .386-.293.717-.635.717h-11.923c-.293 0-.538-.276-.538-.607v-.496c0-.33.245-.607.538-.607Z"
      />
      <Path
        fill="#E9A090"
        d="M154.005 64.191c.098-.662 2.248-2.537 2.346-2.482.098.055 1.417.11 2.394 1.048 1.027.938 2.395 2.372 2.493 2.978.097.662-.489.883-1.564-.165-1.075-1.048-2.492-2.04-3.079-2.04-.537.054-2.59.661-2.59.661Z"
      />
      <Path
        fill="#87621D"
        d="M150.683 72.63c.635-.386-1.759-3.861-3.323-4.799-1.564-.937-2.199-1.103-2.297-.496-.146.607.635 2.537 2.395 4.136 1.759 1.6 3.225 1.158 3.225 1.158Z"
      />
      <Path
        fill="#EBA398"
        d="M143.939 69.651s1.613-2.647 2.101-3.695c.489-1.048 2.199-2.261 4.398-3.199 2.199-.937 5.962-1.71 7.086-.606 1.124 1.103 3.225 4.357 3.371 5.129.147.772-.439.827-.928.606-.538-.22-1.222-1.599-1.564-1.985-.342-.386-1.124-1.158-1.124-1.158s.782 1.379 1.075 1.985c.294.662.978 1.765.342 2.04-.635.277-.928-.165-1.319-1.047-.342-.882-1.857-2.537-1.857-2.537s.929 1.49 1.075 1.93c.147.497.293.993-.146 1.158-.489.166-.929-.11-1.466-.992-.538-.883-1.075-.938-1.075-.938s-.88 1.6-2.444 1.93c-1.319.276-2.541.276-2.541.276-.488.993-1.612 4.247-1.612 4.247l-3.372-3.144Z"
      />
      <Path
        fill="#F5B335"
        d="M138.222 43.4c-3.176 2.867-5.62 8.713-6.841 16.545-1.222 7.831-1.857 20.626.244 23.935 2.052 3.31 4.789 2.868 7.428 1.93 2.638-.937 3.127-7.83 3.127-7.83s.195-14.12 1.222-18.366c2.345-9.872-5.18-16.215-5.18-16.215Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.177}
        d="M141.007 53.437c.391 1.102 2.053 4.963 1.662 9.761-.391 4.798-2.053 11.196-2.053 11.196"
      />
      <Path
        fill="#F5B335"
        d="M145.014 67.28c-.048.386 2.15 3.42 3.616 4.412 1.466.993 2.053.883 2.053.883s-5.571 10.423-8.992 12.299c-3.42 1.875-6.596 1.985-7.476-.828-.88-2.813-1.466-6.673-1.466-6.673s3.714-2.703 5.913-4.909c2.59-2.481 6.352-5.184 6.352-5.184Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.177}
        d="M138.613 72.52c2.639-2.593 6.401-5.24 6.401-5.24-.049.386 2.15 3.42 3.616 4.412 1.466.993 2.053.883 2.053.883s-5.571 10.423-8.992 12.299c-3.42 1.875-8.356 2.481-10.066-1.048"
      />
      <Path
        fill="#EBA398"
        d="M178.536 69.982s-.489.827.88 1.544c2.15 1.158 4.984.331 5.961-.165.978-.497 1.32-1.434 1.32-1.434l-8.161.055Z"
      />
      <Path
        fill="#EBA398"
        d="M179.416 69.983s.635-.22 1.319-.607c.538-.276 1.466-.386 1.955-1.434.44-.937.537-1.6 1.124-1.544.489.055.489.717.489.717s.146-.386.195-.772c.098-.497.293-.552.635-.662.293-.055.636.22.782.496.147.331.098.772.098.772s.195-.772.293-.992c.196-.441.489-.552.831-.497.391.056.488.662.537 1.103.049.331 0 1.048 0 1.048s.049-.993.733-.882c.489.055.587 1.103.489 1.82-.049.606-.196.827-.586 1.323-.88 1.159-6.5 1.6-7.917 1.048-1.368-.551-.977-.937-.977-.937Z"
      />
      <Path
        fill="#EBA398"
        d="M182.543 71.858c-.977.882-2.15 1.82-2.15 1.82s-1.906.055-2.492-1.38c-.636-1.433-.489-2.316-.489-2.316h2.052l3.079 1.876Z"
      />
      <Path
        fill="#0058AD"
        d="M161.384 19.133c-.928.055-2.345.11-2.883.496-.44.331-.342.662-.977.717-.538.055-.587-.275-1.075-.551-.587-.276-2.737 0-3.616.11-.88.11-2.15.441-2.15.883 0 .275.048.606.097.882s.538.33.587.386c.195.11.195.938.537 1.985.44 1.38 1.906 1.6 3.519 1.214 1.466-.386 1.319-2.206 1.466-3.034.097-.661 0-.882.684-.937.684-.055.586.165.782.827.244.772.342 2.427 1.856 2.372 1.515 0 1.76-.938 1.809-2.427.048-1.048 0-1.71-.098-2.316 0-.331-.196-.662-.538-.607Zm-4.935 4.026c-.049 1.048-.049 1.765-1.515 1.875-1.075.11-2.443.055-2.737-1.434-.293-1.544-.293-2.26-.146-2.592.146-.33 1.466-.441 2.59-.496 1.173-.055 1.563-.055 1.71.496.098.276.147 1.103.098 2.151Zm5.277-.993c0 1.545-.439 1.875-.928 2.04-1.124.332-1.564-.275-1.808-1.268-.196-1.047-.244-1.875-.244-2.095.097-.607.488-.717 1.661-.828.684-.055.928-.165 1.075.166.195.33.244.993.244 1.985Z"
      />
      <Path
        fill="#0058AD"
        d="M150.927 20.622c-.88.22-4.105 2.647-4.105 2.647l.733.276s1.368-.386 1.613-.607c.244-.22.44-.772.733-.937.293-.166 1.319-.772 1.319-.772l-.293-.607Z"
      />
      <Path
        fill="#EBA398"
        d="M76.74 41.139c-.146-.607-.293-1.214-.39-1.6-.294-.937-1.32-3.088-1.564-3.585-.196-.496.342-.937 1.075-.165.39.386.733 1.158 1.026 1.71.049.165.146.33.244.496.049-1.268.147-2.868.147-3.199 0-.717-.293-2.647-.391-3.42-.098-.771.635-.882 1.173-.22.537.717.537 1.434.781 2.317.245.937.245 2.757.245 2.757l.342-1.103c.342-1.103.928-3.585.88-4.412-.098-.827.146-1.544.83-1.103.684.441.635 1.103.635 2.15 0 1.104 0 1.27-.195 2.483-.147.992-.147 1.82-.391 2.978.44-.386 1.662-.772 2.101-.717 1.222.11 2.102.993 2.59 1.654.489.662 1.417 1.269.538 1.6-.88.386-1.417-.828-2.297-1.103-.88-.276-1.662.11-2.004.717-.342.661-.88 3.088 0 3.474.88.386 1.418-.662 1.76-1.544.342-.827 1.319-1.765 1.954-1.544.636.276.587.551.098 1.489-.489.937-1.27 2.537-1.613 3.97-.342 1.435-1.465 2.262-1.954 2.869-.489.661.537 6.011.537 6.011-.977 1.71-4.837 1.6-4.837 1.6s.39-2.538-.098-4.688c-.489-2.151-.635-5.295-.977-7.832-.147-.607-.196-1.324-.245-2.04Z"
      />
      <Path
        fill="#fff"
        d="m81.578 57.85 1.32-2.317-.147-5.129s-4.79-.165-5.816.938l.245 5.129 4.398 1.379Z"
      />
      <Path
        fill="#674B16"
        d="M98.828 45.606c-1.173-4.357-2.493-4.412-2.493-4.412s-3.274.993-6.792 7.777c-1.613 3.088-5.278 14.504-5.473 13.787-.39-1.544-.684-6.894-1.124-10.203 0 0-5.62.331-7.281 1.82 0 0 .538 14.34 1.661 19.414 1.515 6.838 3.86 10.368 7.33 10.478 2.102.056 2.737-1.158 4.007-2.757 2.883-3.585 9.969-22.006 10.849-26.418.879-4.412-.342-8.162-.684-9.486Z"
      />
      <Path
        fill="#121B23"
        d="M104.838 197.161c.195-4.577 1.661-58.901 1.906-63.424.244-4.798-.587-22.17-.587-22.17l-3.909-16.435-9.675-2.537s-2.297 28.623-1.515 40.481c.684 10.589 3.616 56.033 4.642 64.637 1.124.165 7.574.11 9.138-.552Z"
      />
      <Path
        fill="#121B23"
        d="M105.816 135.117c.879 3.364.781 18.089 1.319 26.748 1.319 21.895 1.71 35.462 1.71 35.462 1.857 0 9.383-.386 9.871-.441-.049-3.199 1.368-19.193 2.053-37.172.39-9.927 2.101-35.407 2.199-40.812.244-15.993-1.027-23.384-1.027-23.384l-23.26-2.757 4.007 25.81c1.075 6.674 2.199 12.961 3.128 16.546Z"
      />
      <Path
        fill="#EBA398"
        d="M111.093 29.392c-.097 2.923.44 4.412.929 5.846.439 1.49 5.277 4.633 5.277 4.633S103.03 54.817 97.753 54.596c-5.229-.22 2.59-15.607 2.59-15.607s2.248-1.434 2.736-2.978c.489-1.545.88-5.13.88-5.13l6.304-8.548.83 7.06Z"
      />
      <Path
        fill="#D4877B"
        d="M110.018 35.017c.537-.386 1.075-.772 1.563-1.213-.293-1.103-.537-2.427-.488-4.412l-.831-7.115-6.304 8.494s-.342 3.584-.879 5.129c-.049.22-.147.386-.245.606 3.812.552 5.327-.606 7.184-1.489Z"
      />
      <Path
        fill="#F7EDE6"
        d="M122.43 100.04c.684 1.876 1.075 3.916.684 4.468-.391.551-10.702 1.544-17.738 1.654-7.037.11-13.194-1.213-13.976-3.033-.782-1.765.684-5.57.684-5.57l30.346 2.481Z"
      />
      <Path
        fill="#674B16"
        d="M113.536 37.113s7.477 4.247 8.698 5.626c2.444 2.757 2.737 8.603 2.542 12.519-.147 3.254 2.834 32.54.146 42.963-.44 1.71-2.15 3.915-3.665 4.412-1.173.386-2.59.772-4.251.992-4.447.717-12.314.993-15.637.497-4.007-.607-7.33-1.71-9.53-2.537-1.563-.607-2.247-2.372-2.394-4.247-1.075-15.773 3.763-41.75 4.252-45.003.537-3.86 2.59-11.085 2.59-11.085l4.642-2.703c.147 1.544 2.101 2.592 5.277 2.537 3.763-.11 7.33-3.97 7.33-3.97Z"
      />
      <Path
        fill="#F7EDE6"
        d="M113.194 36.506s-2.541 3.144-7.036 4.522c0 0 1.221.166 2.052.772.782.552 1.368 1.71.831 3.2 0 0 2.981-1.766 4.593-5.295.684-1.545.733-2.482.733-2.482l-1.173-.717ZM101.711 37.389c-.44.551-.978.992-1.564 1.323.049.166.147.386.244.607 1.515 3.64 3.665 5.294 3.665 5.294-.195-1.378-.049-1.985.538-2.867.244-.387 1.417-.717 1.417-.717-2.834-1.048-3.421-2.427-4.3-3.64Z"
      />
      <Path
        fill="#302426"
        d="M99.512 16.266s-1.76-1.71-1.613-3.916c.245-3.474 1.955-2.978 1.955-2.978s-.928-3.42 2.443-4.522c2.346-.717 3.812 1.599 3.812 1.599s.831-2.206 3.274-1.213c1.954.772 1.759 2.426 1.759 2.426s2.199 0 3.567 1.93c1.124 1.6.88 3.806.147 4.909-.733 1.103-7.428 2.427-7.428 2.427l-7.916-.662Z"
      />
      <Path
        fill="#EBA398"
        d="M101.027 14.28c-1.71 2.592-1.857 6.067-1.76 7.942.098 1.875-.097 2.04-.341 4.467-.343 3.144.928 5.35 2.98 6.95 2.541 2.04 7.917.33 9.676-2.648 1.075-1.765 1.612-3.64 2.052-5.184.44-1.545 1.906-6.84.293-9.32-1.612-2.483-4.935-2.98-8.356-2.814-3.42.221-3.811-.496-4.544.607Z"
      />
      <Path
        fill="#302426"
        d="M112.266 21.505s-1.271-2.096-1.466-3.805c-.147-1.6.293-2.923.293-2.923s-1.612.386-2.443.496c-6.011.827-7.819-.607-7.819-.607s-3.86-2.923 2.883-5.294c4.203-1.49 5.278-.441 8.161 0 3.567.551 2.492 3.143 2.492 3.143s1.808.552 2.541 2.923c.733 2.427.147 4.247-.83 6.894-1.32 3.585-4.007 5.24-4.007 5.24l.293-2.041-.147-.276a2.396 2.396 0 0 1-.293-1.82l.342-1.93Z"
      />
      <Path
        fill="#302426"
        d="M105.913 18.03s2.15-.385 4.105 1.49c0 0-.489.22-.635.22-.391-.055-2.541-.882-3.909-.385-.049 0 .048-.883.439-1.324ZM102.639 16.983s-1.221-.441-3.225.938c0 0 .049.606.44.496.391-.11 1.857-.607 2.981-.055-.049-.055.097-.938-.196-1.379ZM108.015 22.389c-.049.551-.342.992-.587.937-.293-.055-.488-.496-.44-1.048.049-.551.343-.992.587-.937.293 0 .488.496.44 1.047ZM101.613 21.67c-.049.552-.342.993-.586.938-.293-.055-.489-.496-.44-1.048.049-.551.342-.992.586-.937.294 0 .489.496.44 1.048Z"
      />
      <Path
        fill="#EBA398"
        d="M112.852 23.877c1.271-1.158 3.079-.607 2.688 1.268-.342 1.544-1.075 1.765-2.345 2.923-.88.772-1.515.22-1.515-.22.049-1.324.391-3.254 1.172-3.971Z"
      />
      <Path
        fill="#D4877B"
        d="M104.056 22.167c-.391.386-.733.827-1.124 1.213-.342.442-.733.883-1.075 1.269l-.244.33-.098.221c-.049.056-.097.166-.146.22 0 .111-.049.166-.049.277v.275a.931.931 0 0 0 .195.386c.391.442.587.552 1.075.717 0 0 .342 0 .147-.165-.196-.166-.88-.496-1.026-.717-.147-.22-.196-.441-.098-.607.049-.055.049-.11.098-.165l.146-.165.245-.332c.342-.44.684-.882.977-1.323.391-.496.684-.938.977-1.434ZM113.732 24.208c.586-.386 1.124-.055 1.173.551.048.607 0 .11-.44-.165-.293-.166-.782.441-.978.937-.342.828-.635 1.655-1.123 1.655-.587-.055-.196-.662.146-1.379.391-.772.733-1.268 1.222-1.6Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.121}
        d="M93.746 52.28s-3.86 24.156-4.105 28.788"
      />
      <Path
        fill="#302426"
        d="M101.857 28.068c.587.441 2.199.165 3.274-.276 0 0-.635 3.033-2.003 2.537-1.124-.441-1.271-2.261-1.271-2.261Z"
      />
      <Path
        stroke="#4A535A"
        strokeMiterlimit={10}
        strokeWidth={1.121}
        d="M103.666 114.711s2.834 21.454 2.931 36.4"
      />
      <Path
        fill="#674B16"
        d="M122.235 42.738c3.274 3.64 5.815 9.431 7.036 17.207 1.222 7.832 1.857 20.627-.244 23.936-2.052 3.309-4.789 2.868-7.428 1.93-2.638-.937-3.127-7.831-3.127-7.831s-.196-14.119-1.222-18.366c-2.296-9.871 4.985-16.876 4.985-16.876Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.121}
        d="M119.694 53.438c-.391 1.102-2.053 4.963-1.662 9.761.391 4.798 2.053 11.196 2.053 11.196"
      />
      <Path
        fill="#803532"
        d="M114.66 69.763c.489-.607 1.564-1.986 1.027-2.482-.538-.497-2.248.937-3.763 2.481-1.515 1.545-2.15 2.096-1.661 3.144.488 1.048 3.713-2.261 4.397-3.144Z"
      />
      <Path
        fill="#F7EDE6"
        d="M113.634 66.067c-.147 0-3.274 2.427-4.007 4.026a.967.967 0 0 0-.147.497c.44.662.831 1.379 1.173 2.096.587 0 1.564-.221 2.639-1.214 1.173-1.103 2.297-2.206 2.59-3.033-.44-.827-2.248-2.372-2.248-2.372Z"
      />
      <Path
        fill="#674B16"
        d="M115.687 67.28c.048.386-2.151 3.42-3.617 4.412-1.466.993-2.052.883-2.052.883s5.571 10.368 8.991 12.243c3.421 1.876 6.597 1.986 7.477-.827.879-2.813 1.466-6.673 1.466-6.673s-3.714-2.703-5.913-4.909c-2.59-2.426-6.352-5.129-6.352-5.129Z"
      />
      <Path
        stroke="#AE7F26"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.121}
        d="M122.088 72.52c-2.639-2.593-6.401-5.24-6.401-5.24.048.386-2.151 3.42-3.617 4.412-1.466.993-2.052.883-2.052.883s5.571 10.368 8.991 12.243c3.421 1.876 8.356 2.482 10.067-1.048"
      />
      <Path
        fill="#D4877B"
        d="M110.018 61.6c-.586-1.268-1.075-1.489-2.345-2.482-1.271-.992-1.76-1.433-2.004-.661s.489 1.544 1.173 2.206c.684.662-.049 1.489.977 1.82.978.44 2.199-.883 2.199-.883Z"
      />
      <Path
        fill="#B7ACAC"
        d="M111.484 72.575a.868.868 0 0 1-.489.165l-14.904-.937c-.293 0-.586-.22-.684-.497L85.78 50.018c-.195-.441-.048-.993.294-1.213.146-.11.293-.166.44-.11l15.734.386c.342 0 .587.22.733.551l8.796 21.84c.244.33.098.882-.293 1.103Z"
      />
      <Path
        fill="#D1CBCB"
        d="m109.92 72.685-14.66-.386c-.342 0-.586-.22-.733-.552l-8.551-21.233c-.244-.607.147-1.324.782-1.324l14.66.387c.342 0 .586.22.733.551l8.551 21.233c.293.662-.147 1.379-.782 1.324Z"
      />
      <Path
        fill="#EBA398"
        d="M110.164 69.266c.196.11.636.22.782.386.831-.33 2.199-1.765 2.444-3.364-.782-.883-2.248-2.372-2.444-2.923-.244-.772-.586-2.261-1.808-2.537-1.221-.276-3.42-.662-4.251-.441-.831.22-.684 1.213-.245 1.544 0 0-.83-.166-1.172.22-.342.386-.342 1.434.684 1.765 0 0-.538.276-.538 1.103 0 .772.782 1.158.782 1.158s-.684.442-.049 1.214c.636.772 2.492 1.103 3.714 1.82 1.271.662 1.466-.22 2.101.055Z"
      />
      <Path
        stroke="#AE7F26"
        strokeMiterlimit={10}
        strokeWidth={1.121}
        d="M85.194 71.803s-.586-6.838-1.564-10.644"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M.298 0h261.807v140H.298z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SupportPeopleLogo;
